// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 100%;
  margin-bottom: 6px;
}

.checkbox-price {
  color: #b5b5b5;
}

.hidden {
  visibility: hidden;
}

.price {
  margin-right: 10px;
  color: var(--ion-color-black);
  font-weight: 400;
}

.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 19px;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
}

ion-checkbox {
  margin: 0 12px 0 0;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
  --inner-padding-start: 20px;
}

ion-label {
  font-size: 14px;
  font-family: AppFont, sans-serif;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,6BAAA;EACA,gBAAA;AACD;;AAGC;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;AAEE;EACC,4BAAA;AAAH;AAGE;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AADH;AAKC;EACC,aAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAOA;EACC,kBAAA;AAJD;;AAOA;EACC,qBAAA;AAJD;;AAMA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;AAHD;;AAKA;EACC,eAAA;EACA,gCAAA;AAFD;;AAKA;EACC,eAAA;AAFD","sourcesContent":["ion-item {\n\twidth: 100%;\n\tmargin-bottom: 6px;\n}\n\n.checkbox-price {\n\tcolor: #b5b5b5;\n}\n\n.hidden {\n\tvisibility: hidden;\n}\n\n.price {\n\tmargin-right: 10px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n}\n\n.qty {\n\t&__btn {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin: 0 !important;\n\t\tbox-shadow: none;\n\t\t--box-shadow: none;\n\n\t\tbutton {\n\t\t\tbox-shadow: unset !important;\n\t\t}\n\n\t\tspan {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\theight: 19px;\n\t\t}\n\t}\n\n\t.qty-number {\n\t\tmargin: 0 4px;\n\t\ttext-align: center;\n\t\tmin-width: 15px;\n\t}\n}\n\nion-checkbox {\n\tmargin: 0 12px 0 0;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n\t--inner-padding-start: 20px;\n}\nion-label {\n\tfont-size: 14px;\n\tfont-family: AppFont, sans-serif;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
